import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

const authStore = (set, get) => ({
  user: null,
  token: null,
  preferedTimezone: null,
  rememberEmail: '',
  selectedOrganization: null,
  org_to_theme: null,
  theme: null,
  user_prefered_lang: null, // Add preferred language state
  posthogAvailability: false,
  masquarding_group_data: null,
  from_masquarding: false,
  is_admin_login_mobile: false,
  isMobile: false,
  orgLoginDisabledModal: null,
  isSuperAdminMasquerading: false,

  openOrgLoginDisabledModal: payload => set({orgLoginDisabledModal: payload}),
  clearOrgLoginDisabledModal: () => set({orgLoginDisabledModal: null}),
  setSuperAdminMasquerading: value => set({isSuperAdminMasquerading: value}),

  loginUser: userData => {
    set(state => {
      let updatedUser = { ...userData };
      if (state.selectedOrganization?.id && updatedUser.user_organizations && Array.isArray(updatedUser.user_organizations)) {
        const targetOrgs = updatedUser.user_organizations.filter(
          uo => String(uo.organization_id) === String(state.selectedOrganization.id) && uo.status !== 'DELETED' && uo.status !== 'INVITED' && uo.status !== 'MOVED' && uo.status !== 'Moved'
        );
        const availableRoles = targetOrgs.map(uo => uo.user_role);
        if (availableRoles.length > 0 && !availableRoles.includes(updatedUser.user_role)) {
          const fallbackRole = availableRoles.includes('DISCIPLE') ? 'DISCIPLE' : (availableRoles.includes('LEADER') ? 'LEADER' : availableRoles[0]);
          updatedUser = { ...updatedUser, user_role: fallbackRole };
        }
      }
      return {
        ...state,
        user: updatedUser,
        token: updatedUser.authToken || state.token,
        preferedTimezone: updatedUser.prefered_timezone || state.preferedTimezone,
        user_prefered_lang: updatedUser.user_prefered_lang || state.user_prefered_lang,
        is_admin_login_mobile: updatedUser.is_admin_login_mobile || false,
        orgLoginDisabledModal: null,
        isSuperAdminMasquerading: false
      };
    });
  },
  logoutUser: () => {
    set(state => ({
      ...state,
      user: null,
      token: null,
      preferedTimezone: null,
      selectedOrganization: null,
      user_prefered_lang: null,
      is_admin_login_mobile: false,
      orgLoginDisabledModal: null,
      isSuperAdminMasquerading: false
    }));
  },
  setRememberEmail: email => {
    set(state => ({
      ...state,
      rememberEmail: email
    }));
  },
  updateUserData: data => {
    set(state => {
      let updatedUser = { ...state.user, ...data };
      if (state.selectedOrganization?.id && updatedUser?.user_organizations && Array.isArray(updatedUser.user_organizations)) {
        const targetOrgs = updatedUser.user_organizations.filter(
          uo => String(uo.organization_id) === String(state.selectedOrganization.id) && uo.status !== 'DELETED' && uo.status !== 'INVITED' && uo.status !== 'MOVED' && uo.status !== 'Moved'
        );
        const availableRoles = targetOrgs.map(uo => uo.user_role);
        if (availableRoles.length > 0 && !availableRoles.includes(updatedUser.user_role)) {
          const fallbackRole = availableRoles.includes('DISCIPLE') ? 'DISCIPLE' : (availableRoles.includes('LEADER') ? 'LEADER' : availableRoles[0]);
          updatedUser = { ...updatedUser, user_role: fallbackRole };
        }
      }
      return {
        ...state,
        user: updatedUser
      };
    });
  },
  updateIsAdminLoginMobile: (value) => {
    set(state => ({
      ...state,
      is_admin_login_mobile: value
    }));
  },
  updateOrgDefaultLanguage: data => {
    set(state => ({
      ...state,
      selectedOrganization: {...state.selectedOrganization, ...data}
    }));
  },
  loginNewUser: data => {
    const organizations = data?.organizations || [];
    const isMasquerading = data?.isSuperAdminMasquerading !== undefined ? data.isSuperAdminMasquerading : get().isSuperAdminMasquerading;
    const currentOrgId = get().selectedOrganization?.id;
    let selectedOrg;
    if (isMasquerading || data?.is_impersonate) {
      selectedOrg = organizations.find(org => String(org.id) === String(currentOrgId)) || organizations[0] || null;
    } else {
      if (data?.active_org_id) {
        selectedOrg = organizations.find(org => String(org.id) === String(data.active_org_id) && org?.deactivate_login !== 1);
      }
      if (!selectedOrg && currentOrgId) {
        selectedOrg = organizations.find(org => String(org.id) === String(currentOrgId) && org?.deactivate_login !== 1);
      }
      
      // Ensure the chosen selectedOrg actually supports the user's assigned role!
      // If it doesn't, reject it and let the fallback logic find the correct one.
      if (selectedOrg && data.user_organizations && Array.isArray(data.user_organizations)) {
        const supportsRole = data.user_organizations.some(uo => String(uo.organization_id) === String(selectedOrg.id) && uo.user_role?.toUpperCase() === data?.user_role?.toUpperCase() && uo.status !== 'DELETED' && uo.status !== 'INVITED' && uo.status !== 'MOVED' && uo.status !== 'Moved');
        if (!supportsRole) {
          selectedOrg = null;
        }
      }
      if (!selectedOrg) {
        if (data.user_organizations && Array.isArray(data.user_organizations)) {
          const orgWithRole = data.user_organizations.find(uo => uo.user_role?.toUpperCase() === data?.user_role?.toUpperCase() && uo.status !== 'DELETED' && uo.status !== 'INVITED' && uo.status !== 'MOVED' && uo.status !== 'Moved');
          if (orgWithRole) {
            selectedOrg = organizations.find(org => String(org.id) === String(orgWithRole.organization_id) && org?.deactivate_login !== 1);
          }
        }
        if (!selectedOrg) {
          const pendingInviteOrgId = data?.pending_move_invite?.orgId;
          selectedOrg = (pendingInviteOrgId ? organizations.find(org => String(org.id) === String(pendingInviteOrgId) && Number(org?.deactivate_login) !== 1) : null) || organizations.find(org => Number(org?.deactivate_login) !== 1 && data?.user_organizations?.some(uo => String(uo.organization_id) === String(org.id) && !['MOVED', 'DROPPED', 'ARCHIVED', 'DELETED', 'INVITED'].includes((uo.status || '').toUpperCase()))) || null;
        }
      }
    }
    let updatedUser = { ...data };
    if (selectedOrg?.id && updatedUser.user_organizations && Array.isArray(updatedUser.user_organizations)) {
      const targetOrgs = updatedUser.user_organizations.filter(
        uo => String(uo.organization_id) === String(selectedOrg.id) && uo.status !== 'DELETED' && uo.status !== 'INVITED' && uo.status !== 'MOVED' && uo.status !== 'Moved'
      );
      const availableRoles = targetOrgs.map(uo => uo.user_role);
      if (availableRoles.length > 0 && !availableRoles.includes(updatedUser.user_role)) {
        const fallbackRole = availableRoles.includes('DISCIPLE') ? 'DISCIPLE' : (availableRoles.includes('LEADER') ? 'LEADER' : availableRoles[0]);
        updatedUser.user_role = fallbackRole;
      }
    }
    set(state => ({
      ...state,
      selectedOrganization: selectedOrg,
      token: data?.authToken,
      user: updatedUser,
      is_admin_login_mobile: data?.is_admin_login_mobile || false,
      orgLoginDisabledModal: null,
      isSuperAdminMasquerading: isMasquerading
    }));
  },
  setOrganization: data => {
    set(state => {
      let updatedUser = state.user;
      if (data?.id && updatedUser?.user_organizations && Array.isArray(updatedUser.user_organizations)) {
        const targetOrgs = updatedUser.user_organizations.filter(
          uo => String(uo.organization_id) === String(data.id) && uo.status !== 'DELETED' && uo.status !== 'INVITED' && uo.status !== 'MOVED' && uo.status !== 'Moved'
        );
        const availableRoles = targetOrgs.map(uo => uo.user_role);
        if (availableRoles.length > 0 && !availableRoles.includes(updatedUser.user_role)) {
          const fallbackRole = availableRoles.includes('DISCIPLE') ? 'DISCIPLE' : (availableRoles.includes('LEADER') ? 'LEADER' : availableRoles[0]);
          updatedUser = { ...updatedUser, user_role: fallbackRole };
        }
      }
      return {
        ...state,
        selectedOrganization: data,
        user: updatedUser
      };
    });
  },
  setOrgToTheme: data => {
    set(state => ({
      ...state,
      org_to_theme: data
    }));
  },
  setTheme: data => {
    set(state => ({
      ...state,
      theme: data
    }));
  },

  updateOrganizationState: (id, avatar, name) => {
    set(state => ({
      ...state,
      selectedOrganization: {...state.selectedOrganization, ...(avatar && {avatar: avatar}), ...(name && {name: name})},
      user: {
        ...state.user,
        organizations: state.user?.organizations?.map(org => {
          if (org.id == id) {
            return {
              ...org,
              ...(name && {name: name}),
              ...(avatar && {avatar: avatar})
            };
          } else {
            return org;
          }
        })
      }
    }));
  },
  updatePosthog: (value) => {
    set(state => ({
      ...state,
      posthogAvailability: value
    }))
  },
  updateUserPreferedLang: lang => {
    set(state => ({
      ...state,
      user_prefered_lang: lang,
      user: state.user ? {...state.user, user_prefered_lang: lang} : null
    }));
    // window.location.reload();
  },

  setMasquardingGroup: groupData => {
    set(state => {
      const newState = {
        ...state,
        masquarding_group_data: groupData,
        from_masquarding: false
      };
      return newState;
    });
  },

  exitMasquarding: () => {
    set(state => {
      const newState = {
        ...state,
        from_masquarding: true
      };
      return newState;
    });
  },

  setIsMobile: isMobile => {
    set(state => ({
      ...state,
      isMobile: isMobile
    }));
  },
  clearMasquarding: () => {
    set(state => {
      const newState = {
        ...state,
        masquarding_group_data: null,
        from_masquarding: false
      };
      return newState;
    });
  }
});

const useAuthStore = create(
  persist(authStore, {
    name: 'auth-storage',
    storage: createJSONStorage(() => localStorage),
    partialize: state =>
      Object.fromEntries(
        Object.entries(state).filter(([key, value]) => typeof value !== 'function' && key !== 'orgLoginDisabledModal')
      )
  })
);

export default useAuthStore;
